<template>
  <div class="pa-4">
    <v-card class="elevation-0" color="transparent">
      <v-toolbar card color="transparent" class="cactus-filter--toolbar">
          <v-text-field
            solo-inverted
            prepend-inner-icon="search"
            clearable
            v-model="filterOptions.searchQuery"
            v-on:keyup="searchTaxonomy"
            @click:clear="clearSearch"
            flat>
            <template v-slot:label>
             Search by name or id <span v-if="!filterOptions.exactTextSearch"><em>(use * for name fuzzy matching ex: dsm*)</em></span>
            </template>
            <template v-slot:append-outer>
              <v-tooltip bottom>
                <template v-slot:activator="{ on }">
                  <v-icon @click="showFilters = !showFilters" v-on="on">
                    filter_list
                  </v-icon>
                </template>
                <span>View filter options</span>
              </v-tooltip>

            </template>
          </v-text-field>
          <v-btn icon @click="refreshTaxonomy" color="green">
            <v-icon>refresh</v-icon>
          </v-btn>
          <v-spacer></v-spacer>
      </v-toolbar>
      <v-card-text v-if="showFilters" class="pa-0">
        <v-layout>
          <div style="padding-right: 16px;">
          <v-checkbox
            v-model="filterOptions.exactTextSearch"
            dense
            label="Search exact"
          ></v-checkbox>
          </div>
          <div>
            <v-select
              :items="rankNames"
              dense
              v-model="filterOptions.rank"
              clearble
              label="Rank">
            </v-select>
          </div>

        </v-layout>
      </v-card-text>
      <v-data-table
        :headers="headers"
        :items="items"
        :loading="loading"
        dense
        hide-actions
        class="elevation-1"
      >
        <template v-slot:items="props">
          <td style="width: 80px;">
            <router-link :to="{name:'view-taxonomy', params:{id: props.item.taxonomy_id}}">{{props.item.taxonomy_id}}</router-link>
          </td>
          <td style="width: 80px;" class="text-xs-left">
            <a target="_" :href="`https://www.ncbi.nlm.nih.gov/Taxonomy/Browser/wwwtax.cgi?id=${props.item.ncbi_id}`">{{ props.item.ncbi_id}}</a>
          </td>
          <td class="text-xs-left" :class="{'active-column': rankName === filterOptions.rank}" v-for="rankName in rankNames" :key="rankName">
            {{props.item.tax[rankName]}}
          </td>
        </template>
      </v-data-table>
      <InfiniteLoading @infinite="scrollLoad" :identifier="infiniteLoaderId"></InfiniteLoading>
    </v-card>
  </div>
</template>

<script>
import TaxonomyAPI from '@/api/taxonomy.js'
import InfiniteLoading from 'vue-infinite-loading'
import {isInt} from '@/utils/helpers.js'

export default {
  components: {
    InfiniteLoading
  },
  data () {
    return {
      showFilters: false,
      loading: true,
      filterOptions: {
        exactTextSearch: false,
        rank: 'strain',
        searchQuery: ''
      },
      rankNames: [
        'kingdom',
        'phylum',
        'class',
        'order',
        'family',
        'genus',
        'species',
        'strain'
      ],
      pagination: {
        perPage: 100,
        page: 0
      },
      items: [],
      infiniteLoaderId: +new Date()
    }
  },
  computed: {
    headers () {
      const taxHeaders = this.rankNames.map((n) => ({'text': n, 'value': `tax.${n}`, sortable: false}))
      return [
        {
          text: 'Taxonomy Id',
          value: 'taxonomy_id',
          sortable: false
        },
        {
          text: 'NCBI Id',
          value: 'ncbi_id',
          sortable: false
        },
        ...taxHeaders
      ]
    },
    filterParams () {
      let value = this.filterOptions.searchQuery || ''
      if (!isInt(value)) {
        return {
          name: {
            filter: this.filterOptions.exactTextSearch ? 'equals' : 'ilike',
            value: this.filterOptions.searchQuery || ''
          },
          rank: {
            filter: 'equals',
            value: this.filterOptions.rank
          }
        }
      }

      return {
        taxonomy_id: {
          filter: 'equals',
          value: value
        }
      }
    }
  },

  methods: {
    async scrollLoad ($state) {
      // $state from infinite-loader component
      const data = await this.getTaxonomy()
      if (data.length) {
        this.items = [...this.items, ...data]
        this.pagination.page += 1
        $state.loaded()
        data.length < this.pagination.perPage && $state.complete()
      } else {
        $state.complete()
      }
    },
    async getTaxonomy () {
      this.loading = true
      const params = {
        limit: this.pagination.perPage,
        offset: this.pagination.page * this.pagination.perPage
      }
      const filterParams = this.filterParams
      const {data} = await TaxonomyAPI.getTaxFull({filterParams, params}, true)
      this.loading = false
      return data
    },
    async refreshTaxonomy () {
      this.infiniteLoaderId += 1 // resets the infinite loader when filters change
      this.resetPagination()
      this.items = []
    },
    searchTaxonomy (e) {
      e.key === 'Enter' && this.filterOptions.searchQuery &&
        this.filterOptions.searchQuery.trim() !== '' && this.refreshTaxonomy()
    },
    clearSearch () {
      this.filterOptions.searchQuery = ''
      this.refreshTaxonomy()
    },
    resetPagination () {
      this.pagination.page = 0
    }
  }
}
</script>

<style lang="scss">
.active-column {
  background: rgba(219, 216, 216, 0.815);
}
</style>
